import { Group } from '@mantine/core';
import { SocialLinkItem } from './SocialLinkItem';
export const SocialLinks: React.FC = () => {
  return <Group gap={8} align="center">
      <SocialLinkItem iconClassName="icon-pr-flat-google" href="#" />
      <SocialLinkItem iconClassName="icon-pr-flat-telegram" href="#" />
      <SocialLinkItem iconClassName="icon-pr-flat-steam" href="#" />
      <SocialLinkItem iconClassName="icon-pr-flat-twitch" href="#" />
    </Group>;
};